






















import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import BaseFaqCard from './BaseFaqCard.vue';    
import faqCards from '../store/faq-cards';


@Component({
    components: {
        BaseFaqCard
    }
})
export default class TheHomePageFAQSection extends Vue {
    faqCards = faqCards;
}
